



<footer class="footer footer-list py-4">
  <div class="cont ">
    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-4 footer-main">

      <!-- Logo -->
      <div class="footer-logo text-center text-lg-start">
        <a class="navbar-brand d-inline-block" href="#">
          <img src="../../assets/images/login-logo(crop).png" alt="Property Box Logo"
            class="img-fluid" style="max-width: 155px; cursor: pointer;" >
        </a>
      </div>

      <!-- About -->
      <div class="footer-about">
        <div class="fw-bold text-uppercase mb-2">About</div>
        <div class="d-flex flex-column gap-2">
          <a class="text-decoration-none" href="javascript:void(0)"
            (click)="scrollToSection('contactus')">Contact Us</a>
          <div class="cursor" (click)="whoAreWe()">Who Are We</div>
          <div class="cursor" (click)="privacyPolicy()">Privacy Policy & Terms of Use</div>
        </div>
      </div>

      <!-- Product -->
      <div class="footer-product">
        <div class="fw-bold text-uppercase mb-2">Product</div>
        <div class="d-flex flex-column gap-2">
          <a class="text-decoration-none" href="javascript:void(0)"
            (click)="scrollToSection('categories')">Investment Properties</a>
          <div class="cursor" (click)="pricingList()">Pricing</div>
        </div>
      </div>

      <!-- Social & App Links -->
      <div class="footer-followus">
        <div class="fw-bold text-uppercase mb-2">Follow Us</div>
        <div class="d-flex flex-wrap gap-2 mb-3">
          <a href="https://www.facebook.com/profile.php?id=61576757992284" target="_blank">
            <img src="../../assets/images/facebook-circle.svg" alt="Facebook" width="32">
          </a>
          <a href="https://www.instagram.com/property__box?igsh=MWVnYmc2Ym8zZWNudw==" target="_blank">
            <img src="../../assets/images/instagram.svg" alt="Instagram" width="32">
          </a>
          <a href="https://www.linkedin.com/company/property-box-private-limited" target="_blank">
            <img src="../../assets/images/linkedin.svg" alt="LinkedIn" width="32">
          </a>
          <a href="https://x.com/propertyboxind" target="_blank">
            <img src="../../assets/images/x.svg" alt="Twitter" width="32">
          </a>
          <a href="https://www.youtube.com/@PropertyBox-pb" target="_blank">
            <img src="../../assets/images/youtube.svg" alt="YouTube" width="32">
          </a>
        </div>

        <div class="app-store-links-wrapper">
          <div class="d-flex flex-row p-lg-2 justify-content-end align-items-center gap-3 app-store-links">
            <!-- Google Play Link -->
            <a href="https://play.google.com/store/apps/details?id=in.axivise.realtbox" target="_blank"
              class="store-link">
              <img src="../../assets/images/Google_Play_Store.svg" alt="Get it on Google Play"
                class="store-badge img-fluid">
              <!-- Make sure this path is correct relative to your HTML file -->
            </a>

            <!-- Apple App Store Link -->
            <a href="https://apps.apple.com/gb/app/propertybox/id6503969578" target="_blank" class="store-link">
              <img src="../../assets/images/app-store-apple-logo.svg" alt="Download on the App Store"
                class="store-badge img-fluid">
              <!-- Make sure this path is correct relative to your HTML file -->
            </a>
          </div>
        </div>

      </div>
    </div>

    <!-- Bottom Text -->
    <div class="text-center border-top mt-3 pt-3">
      <div>© 2024 - All Rights Reserved Property Box India Private Limited</div>
    </div>
  </div>
</footer>
